import React, { Component, Fragment } from 'react';
import { history } from 'components/App/components/UnauthenticatedApp';
import { connect } from 'react-redux';
import './Menu.module.scss';
import customIsoString from 'utilities/custom-iso-string';

//import components
import DefaultButton from 'components/UI/Button/Button';

//import Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { homeworkUpdateDirectInputSwitcher } from 'actions/new-homework';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { faBadgeCheck, faCog } from '@fortawesome/pro-solid-svg-icons';

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user
    };
};

const mapDispatchToProps = {
    homeworkUpdateDirectInputSwitcher
};

class Menu extends Component {

    constructor() {
        super();

        this.state = {
            initials: '',
        };

        this.handleClick    = this.handleClick.bind(this);
        this.goToTips       = this.goToTips.bind(this);
        this.getInitials    = this.getInitials.bind(this);
    }

    componentDidMount() {
        this.getInitials(this.props.user && this.props.user.name);
    }

    handleClick() {
        history.push('/agenda');
        this.props.homeworkUpdateDirectInputSwitcher(true);
        this.props.handleClose();
    }
    
    goToTips() {
        history.push('/tips');
    }

    goToProfile() {
        history.push('/profile');
    }

    goToHome() {
        history.push('/agenda');
    }

    forceReload() {
        window.location.reload(true);
    }

    getInitials(name) {

        let trimName = name.trim();
        var split = trimName.split(' ');

        var abbreviation = '';
        var firstLetter = '';
        var lastLetter = '';

        //Take first letter of first index in array
        firstLetter = split[0][0] ? split[0][0] : '';
        //Check if array is longer than 1 -> Then we have multiple names in the array. Check if the last index is not empty -> Otherwise render '' instead of undefined.
        lastLetter = split.length > 1 ? (split[(split.length - 1)] ? split[(split.length - 1)][0] : '') : '';
        
        abbreviation = firstLetter + lastLetter;

        this.setState({
            initials: abbreviation
        });

    }

    render() {
        const { open, click } = this.props;
        let daysTillLicenseEnds = 0;

        if (this.props.user && this.props.user.has_valid_license && this.props.user.license_ends_at) {
            let dateString = this.props.user.license_ends_at;
            dateString = dateString.replace(' ', 'T');
            let today = new Date();
            let licenseEnd = new Date(dateString);

            // To calculate the time difference of two dates 
            let Difference_In_Time = licenseEnd.getTime() - today.getTime(); 
            // To calculate the no. of days between two dates 
            daysTillLicenseEnds = Difference_In_Time / (1000 * 3600 * 24); 
        }

        return (
            <div onClick={(e) => e.stopPropagation()} styleName={'menu-background ' + (open ? 'visible' : '')}>
                <div styleName='menu-content'>
                    <div styleName='menu-top-bar'>
                        <div styleName='hamburger-button' onClick={click}><FontAwesomeIcon icon={[ 'far', 'bars' ]}/></div>
                        <img onClick={this.goToHome} styleName='logo' src='/images/logos/plenda-logo.svg'/>
                        <div onClick={this.goToProfile} styleName='user-icon'>
                            {this.state.initials}
                        </div>
                    </div>
                    <img styleName='mountains-image' src='/images/mountains.svg'/>
                    <div styleName='menu-buttons'> 
                        <div>
                            <div styleName='button' onClick={() => { 
                                history.push('/agenda'); 
                                this.props.handleClose(); 
                            }}>
                                <FontAwesomeIcon icon={faCalendar}/>
                                <h2>Agenda &#38; takenlijst</h2>
                            </div>
                            
                            <div styleName='button' onClick={() => { 
                                history.push('/settings'); 
                                this.props.handleClose(); 
                            }}>
                                <FontAwesomeIcon icon={faCog}/>
                                <h2>Instellingen</h2>
                            </div>
                            
                            <div styleName='button' onClick={() => { 
                                history.push('/tips'); 
                                this.props.handleClose(); 
                            }}>
                                <FontAwesomeIcon icon={faBadgeCheck}/>
                                <h2>Tips &#38; tricks</h2>
                            </div>
                        </div>
                        {
                            (this.props.user.on_trial || !this.props.user.has_valid_license) &&
                                <div styleName='button licence' onClick={() => { 
                                    history.push('/profile'); 
                                    this.props.handleClose(); 
                                }}>
                                    <h2>Licentie afsluiten</h2>
                                </div>
                        }

                        {
                            daysTillLicenseEnds > 0 && daysTillLicenseEnds < 15 &&
                            <div styleName='button licence' onClick={() => { 
                                history.push('/profile'); 
                                this.props.handleClose(); 
                            }}>
                                <h2>Licentie verlengen</h2>
                            </div>
                        }
                    </div>
                </div>
                
                <div styleName='footer'>
                    <hr width='80%'/>
                    <p styleName='tips' onClick={this.forceReload}>Check voor update (V1.4.2)</p>
                    <a styleName='tips' href="mailto:info@plenda.nl">Feedback</a>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
